import { useQuery } from '@tanstack/react-query';
import { getUserSellTractors, IGetUserSellTractorsParams } from '../../../../api/user/queries/getUserSellTractors';
import { IOpenMarketProduct } from '../../../../interfaces/OpenMarketProduct.interfaces';
import { useCheckUserLoggedIn } from '../../../user/useCheckUserLoggedIn';

export const useGetUserSellTractors = ({ searchParam }: IGetUserSellTractorsParams) => {
  const { isUserLoggedIn } = useCheckUserLoggedIn();

  return useQuery<IOpenMarketProduct[]>(
    ['user_sell_tractors/mine', `machineType=${searchParam.machineType}`],
    () => getUserSellTractors({ searchParam }),
    {
      enabled: isUserLoggedIn,
    },
  );
};
